























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

interface EventoCurrier {
  office: string;
  status: string;
  datetime: string;
  location: string;
}

@Component
class ModalEventosCurrier extends Vue {
  @Prop({ required: true, default: false }) dialog!: boolean;
  @Prop({ required: true, default: '' }) despaseguimiento!: string;
  @Prop({ required: true, default: (): EventoCurrier[] => [] })
  events!: EventoCurrier[];

  formatDatetime(value: string): string {
    if (!value) return '—';
    return moment(value).format('DD/MM/YYYY HH:mm');
  }

  cerrar(): void {
    this.$emit('cerrar');
  }
}

export default ModalEventosCurrier;
